import { getLayers, type GetLayersQueryParams } from '@gonfalon/openapi/operations/getLayers';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { createQueryOptions } from '../internal/createQueryOptions';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export const getLayersQuery = createQueryOptions(getLayers);

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const layers = createQueryKeys('layers', {
  list: ({ projectKey, params }: { projectKey: string; params?: GetLayersQueryParams }) => ({
    queryKey: [projectKey, ...(params ? [params] : [])],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getLayers({ projectKey, query: params }, { signal })),
  }),
});

export const layersList = layers.list;
